<template>
  <!-- Be sure to use this with a layout container that is full-width on mobile -->
  <div class="bg-white shadow rounded-lg">
    <div class="px-8 py-8 sm:p-6">
      <slot />
      <!-- Content goes here -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'Card',
  setup() {
    return {};
  }
};
</script>
